import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import "./checkbox.css";
import { subject } from "../../service";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import PanazCreative from "../NewCreatives/PanazCreative/PanazCreative";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import PanazVerticalAd from "../../assets/Ads/PanazV.jpg";

const headerMap = {
  1: MedizenVerticalAd,
  2: PrimeraVerticalAd,
  3: PanazVerticalAd,
};

export default function BloodTest() {
  let value = window.sessionStorage.getItem("keyselected");

  const handleChange = (event) => {
    sendMessage(event.target.value);
  };
  const sendMessage = (value) => {
    let imagesel = {
      headerImg: headerMap[value],
      bottomImg: "",
      useThis: true,
    };

    subject.next(imagesel);
  };

  return (
    <div
      style={{
        paddingTop: 10,
        paddingLeft: 40,
      }}
    >
      <Grid container spacing={1}>
        <Grid item md={4} style={{ marginTop: 20 }}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position">
              <FormControlLabel
                value="1"
                control={
                  <Checkbox className="clickable" onChange={handleChange} />
                }
                label="Ultrasound"
                labelPlacement="Ultrasound"
              />
              <FormControlLabel
                value="Coronary angiogram"
                control={<Checkbox disabled />}
                label="Coronary angiogram"
                labelPlacement="Coronary angiogram"
              />
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item md={4} style={{ marginTop: 20 }}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position" coloumn>
              <FormControlLabel
                value="1"
                control={
                  <Checkbox className="clickable" onChange={handleChange} />
                }
                label="CT Scan"
                labelPlacement="CT Scan"
              />
              <FormControlLabel
                value="Coronary Angiogram"
                control={<Checkbox disabled />}
                label="Echocardiogram"
                labelPlacement="Echocardiogram"
              />
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item md={4} style={{ marginTop: 20 }}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position" coloumn>
              <FormControlLabel
                value="3"
                control={
                  <Checkbox className="clickable" onChange={handleChange} />
                }
                label="Bone Marrow Biopsy"
                labelPlacement="Bone Marrow Biopsy"
              />
              <FormControlLabel
                value="Lymphocyte (Blood)"
                control={<Checkbox disabled />}
                label="Stress test"
                labelPlacement="Stress test"
              />
            </FormGroup>
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
}
